
import Shifty from '@deepsource/shifty'
import { defineComponent } from 'vue'
import ActiveUserMixin from '~/mixins/activeUserMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import WebhookMixin from '~/mixins/webhookMixin'

export default defineComponent({
  name: 'CreateWebhookModal',

  mixins: [WebhookMixin, ActiveUserMixin, OwnerDetailMixin],

  data() {
    return {
      savingWebhookEndpoint: false,
      url: '',
      secret: '',
      enableApiSigning: true,
      isSecretHidden: true,
      selectedEvents: [] as string[],
      engine: null as Shifty | null
    }
  },

  async fetch() {
    await this.fetchWebhookEventTypesList()
  },

  mounted() {
    this.generateSecret()
  },

  methods: {
    async saveConfig(close: () => void): Promise<void> {
      try {
        this.validateWebhookForm(this.url, this.enableApiSigning, this.secret, this.selectedEvents)
      } catch (e) {
        this.$toast.info((e as Error).message)
        return
      }

      const args = {
        url: this.url,
        secret: this.enableApiSigning ? this.secret : '',
        apiSigning: this.enableApiSigning,
        eventsSubscribed: this.selectedEvents,
        ownerId: this.owner.id
      }

      this.savingWebhookEndpoint = true
      try {
        const response = await this.createEndpoint(args)
        const { owner, provider } = this.$route.params

        this.$toast.success('Webhook endpoint saved successfully.')
        if (response.webhook?.id) {
          this.$router.push(
            this.$generateRoute(['settings', 'webhooks', response.webhook?.id], false, true)
          )
        }
        await this.fetchWebhookEndpoints({
          login: owner,
          limit: 25,
          currentPage: 1,
          provider,
          refetch: true
        })
        close()
      } catch (e) {
        this.$toast.danger((e as Error).message)
        this.$toast.danger(
          'There was a problem saving this endpoint. If this issue persists, contact support.'
        )
        this.logErrorForUser(e as Error, 'webhook endpoint creation', args)
      } finally {
        this.savingWebhookEndpoint = false
      }
    },

    generateSecret(): void {
      if (!this.engine) this.engine = new Shifty(false, 32)

      this.secret = this.engine.generate()
      if (this.isSecretHidden) {
        this.isSecretHidden = false
        setTimeout(() => {
          this.isSecretHidden = true
        }, 1000)
      }
    },

    toggleSecretVisibility(): void {
      this.isSecretHidden = !this.isSecretHidden
    },

    onModalClose(): void {
      if (!this.isSecretHidden) this.isSecretHidden = true
      this.$emit('close')
    }
  },

  watch: {
    '$route.path': {
      handler() {
        this.$emit('close')
      }
    }
  }
})
